import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * PageContainer - A consistent page wrapper component
 *
 * Props:
 * - title: Page title (string)
 * - subtitle: Optional subtitle text (string)
 * - actions: Optional action buttons (React node)
 * - children: Page content
 * - maxWidth: Optional max width (string, e.g., '1400px', 'lg', 'xl')
 */
const PageContainer = ({
  title,
  subtitle,
  actions,
  children,
  maxWidth = '100%',
  noPadding = false
}) => {
  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 128px)',
        bgcolor: 'background.default',
        p: noPadding ? 0 : { xs: 2, sm: 3 },
      }}
    >
      <Box
        sx={{
          maxWidth: maxWidth,
          mx: 'auto',
        }}
      >
        {/* Page Header */}
        {(title || actions) && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              justifyContent: 'space-between',
              alignItems: { xs: 'flex-start', sm: 'center' },
              gap: 2,
              mb: 3,
            }}
          >
            <Box>
              {title && (
                <Typography
                  variant="h4"
                  component="h1"
                  sx={{
                    color: 'text.primary',
                    fontWeight: 600,
                  }}
                >
                  {title}
                </Typography>
              )}
              {subtitle && (
                <Typography
                  variant="body1"
                  sx={{
                    color: 'text.secondary',
                    mt: 0.5,
                  }}
                >
                  {subtitle}
                </Typography>
              )}
            </Box>
            {actions && (
              <Box
                sx={{
                  display: 'flex',
                  gap: 1,
                  flexWrap: 'wrap',
                }}
              >
                {actions}
              </Box>
            )}
          </Box>
        )}

        {/* Page Content */}
        {children}
      </Box>
    </Box>
  );
};

export default PageContainer;
